export const HERO_IMG =
  "https://images.pexels.com/photos/31650383/pexels-photo-31650383.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
export const SILHOUETTE_IMG =
  "https://images.pexels.com/photos/36455649/pexels-photo-36455649.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
export const WAVE_IMG =
  "https://images.unsplash.com/photo-1760978631985-590e3b5f4057?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxkYXJrJTIwbHV4dXJ5JTIwYWJzdHJhY3QlMjBnb2xkfGVufDB8fHx8MTc4NzYyODAwNXww&ixlib=rb-4.1.0&q=85";
export const TEXTURE_IMG =
  "https://images.pexels.com/photos/18415806/pexels-photo-18415806.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
